export const layoutBodyColor = '#F5F4FE';
